module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "envelope-error.b37174bf.svg";